export default __webpack_public_path__ + "static/media/slider.545c1ce0.jpg";